import './App.css';
import Home from './Components/Basic/Home';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
